import styled from 'styled-components';

export const SpinnerContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: 100vh;
`;

export const RouterContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;
